import {
  EMPLOYEES_LIST_RESPONSE,
  GET_EMPLOYEE_DETAILS_RESPONSE,
  GET_EMPLOYEE_PROFILE_RESPONSE
} from "./types";

const INITIAL_STATE = {
  employeesList: {
    list: [],
    meta: {}
  },
  employeeDetails: {}
};

const employees = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case EMPLOYEES_LIST_RESPONSE:
      return {
        ...state,
        employeesList: {
          list: action.payload.list,
          meta: action.payload.meta
        }
      };
    case GET_EMPLOYEE_DETAILS_RESPONSE:
      return {
        ...state,
        employeeDetails: action.payload
      };

    default:
      return state;
  }
};

export default employees;
